import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import filterChildren from "../../utils/Children/filterChildren";
import "./Table.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const Table = _ref => {
  let {
    id = "",
    className = "",
    onCellClick = null,
    noBorder = false,
    responsiveCardStyle = false,
    secondaryDataList = [],
    style = {},
    children = []
  } = _ref;
  /**
   * on cell click will return rowIndex and columnIndex
   * @param {number} row
   * @param {number} column
   * @public
   */
  const handleCellClick = (row, column, event) => {
    if (onCellClick) {
      onCellClick(row, column, event);
    }
  };
  const tableClass = cn({
    "rounded overflow-auto w-full app-components-table border border-solid border-light-border-blue": true,
    "border-none": noBorder,
    "app-components-table--responsive-cards": responsiveCardStyle
  }, className);
  const newChildren = filterChildren(children, {
    onCellClick: onCellClick ? handleCellClick : undefined,
    parent: "table",
    secondaryDataList
  });
  return /*#__PURE__*/_jsx("div", {
    id: id,
    className: tableClass,
    style: style,
    children: /*#__PURE__*/_jsx("table", {
      className: "border-collapse font-regular-font w-full",
      children: newChildren
    })
  });
};
Table.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /**
   * Called when a row cell is clicked.  Returns a row number
   */
  onCellClick: PropTypes.func,
  /** Bool to remove the border around the Table */
  noBorder: PropTypes.bool,
  /** Bool to display the table rows as cards on small screens */
  responsiveCardStyle: PropTypes.bool,
  /** Data (in columns) to hide passed from TableRow component */
  secondaryDataList: PropTypes.array,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node
};
export default Table;
//# sourceMappingURL=Table.js.map